import React from 'react'; 
import { FormNumericTextBox } from '../validation/Form-Components';
import { Field } from '@progress/kendo-react-form';
 
  
const TotalFinancingAmt = (props) => {

    const{leftLabel,id,name,placeholder,min,max,validator,value, descLabel,disabled} = props;
  
    return(
        <div className="row around-xs elementVisible">
                <div className='graydiv row around-xs elementVisible' style={{width:'100%',margin:'3.5%'}}>
                    <div className="col-xs-12 col-sm-5 col-md-5 col-lg-5">
                        {leftLabel}
                    </div> 
                    <div className="col-xs-12 col-sm-7 col-md-7 col-lg-7">
                        <Field component={FormNumericTextBox}
                            id={id}
                            name={name}
                            placeholder={placeholder}
                            maxLength={max} 
                            validator={validator}
                            spinners={false} 
                            format="c2"
                            min={min}
                            max={max}
                            disabled={disabled}
                        />
                        <span className='smallFontSize greyLabel'>{descLabel}</span>
                    </div>
                </div>
        </div>
   
    )
}

export default TotalFinancingAmt